import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/page.js"

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>

<MDXTag name="h3" components={components} props={{"id":"usage-for-ProfileCard"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#usage-for-ProfileCard","aria-label":"usage for ProfileCard permalink","class":"anchor"}}></MDXTag>{`usage for ProfileCard`}</MDXTag>
           </MDXTag>
  }
}

export const _frontmatter = {};

  